"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Random = void 0;
const uuid_1 = require("uuid");
class Random {
    static uuid() {
        return (0, uuid_1.v4)();
    }
    static hash() {
        return Random.uuid().replace(/-/g, '');
    }
}
exports.Random = Random;
